// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        //suggestionMode: 'test'
        //suggestionPosition: 'left'
    }
};

(function () {  // Add this
    BoostPFS.inject(this);  // Add this
    
  	// Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    };
})();  // Add this at the end